import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router
} from '@angular/router';


import { userAccountsDomainsService } from '../apiclient/userAccountsDomains/userAccountsDomains.service';
import { environment } from 'src/environments/environment';
import { ToolsService } from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})

export class GuardUserDomainService implements CanActivate {

  constructor(

    private router: Router,
    private userAccountsDomainsService: userAccountsDomainsService,
    private tools: ToolsService
  ) { }

  determineUrl(): boolean {
    const origin = window.location.origin;

    // Mode test
    if (!environment.production) {
      return true;
    }

    // Mode production
    else if (origin.includes('projetclient-209012.ew.r.appspot.com')) {
      return true;
    }

    return origin == 'https://webshop.fulleapps.io';
  }

  canActivate(
    next: ActivatedRouteSnapshot | any,
    state: RouterStateSnapshot): any {

    let determineUrl = this.determineUrl();

    return new Promise(resolve => {

      this.tools.removeStor("domainUser");
      this.tools.setFavicone(false);
      if (!determineUrl) {


        this.userAccountsDomainsService.getUserAccountDomain(window.location.host, true).subscribe((domain: any) => {


          let flag = false;

          if (domain) {

            let url = null;
            let denomination = domain.denomination ? domain.denomination.replaceAll(' ', '-') : null;
            denomination = denomination ? denomination.toLowerCase() : null;
            if (denomination) {
              url = "/p/" + denomination + "/" + domain.id_merchant;
              flag = state.url == url ? true : false;

              this.tools.setStor("domainUser", true);
              this.tools.setFavicone(true);
            }

          }
          else {
            flag = false;
          }

          //TODO
          //!flag ? location.replace(urlto) : null;
          resolve(flag);

        })

      }
      else {
        resolve(true);
      }
    })
  }

}
